if (!customElements.get('slider-component')) {
  class SliderComponent extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.initializeSlider();
    }

    initializeSlider() {
      this.accordionButton = this.closest('accordion-button');

      if (this.accordionButton && !this.accordionButton.classList.contains('animated-dropdown--active')) {
        this.accordionButton.addEventListener('opened', () => {
          if(this.accordionButton.classList.contains('slider-loaded')) return;
          this.initializeSlider();
          this.accordionButton.classList.add('slider-loaded');
        });
        return;
      }

      this.slider = this.querySelector('ul.slider, [id^="Slider-"]');
      
      if (!this.slider) return;
      
      this.sliderItems = this.querySelectorAll('ul.slider li, [id^="Slide-"]');
      this.enableSliderLooping = false;
      this.currentPageElement = this.querySelector('.slider-counter--current');
      this.pageTotalElement = this.querySelector('.slider-counter--total');
      this.prevButton = this.querySelector('button[name="previous"]');
      this.nextButton = this.querySelector('button[name="next"]');
      this.bullets = this.querySelectorAll('button[name="bullet"]');

      this.initPages();
      
      if (this.sliderItemsToShow.length < 2) return;
      
      const resizeObserver = new ResizeObserver((entries) => this.initPages());
      resizeObserver.observe(this.slider);

      this.slider.addEventListener('scroll', this.update.bind(this));

      if (this.prevButton) {
        this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
      }
      if (this.nextButton) {
        this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
      }
      if (this.dataset.autoplay !== undefined && this.sliderItemsToShow.length > 1) {
        this.startAutoplay();
      }
    }

    initPages() {
      this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);

      if (this.sliderItemsToShow.length < 2) return;

      this.bulletsToShow = Array.from(this.bullets).filter((element) => element.clientWidth > 0);
      this.sliderItemsBanner = Array.from(this.sliderItems).map((element) => element.querySelector('.banner'));
      this.sliderItemsMedia = Array.from(this.sliderItems).map((element) => element.querySelector('.slideshow__media'));
      this.sliderItemsAdditionalMedia = Array.from(this.sliderItems).map((element) => element?.querySelectorAll('.slideshow__additional-media'));
      this.sliderItemsImgs = Array.from(this.sliderItemsMedia).map((element) => element?.querySelectorAll('img'));
      this.sliderItemsContent = Array.from(this.sliderItems).map((element) => element.querySelector('.banner__content'));
      this.sliderItemsBox = Array.from(this.sliderItems).map((element) => element.querySelector('.banner__box'));
      this.sliderItemsContentElements = Array.from(this.sliderItemsContent).map((element) => element?.querySelectorAll('.slideshow__content-element'));
      this.sliderLastItem = this.sliderItemsToShow[this.sliderItemsToShow.length - 1];
      this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
      this.sliderItemGap = Math.abs(this.sliderItemsToShow[0].offsetLeft + this.sliderItemsToShow[0].clientWidth - this.sliderItemsToShow[1].offsetLeft);

      this.slidesPerPage = Math.round(
        (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
      );
      this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
      this.slidePositionRatio = [];
      this.slidePositionFullPercent = [];
      this.slidePositionPercent = [];

      if(this.bulletsToShow.length > 1) {
        this.bulletsToShow.forEach((element, index) => {
          element.onclick = null;
          element.addEventListener('click', this.onBulletClick.bind(this, index));
        });
      }

      this.update();
    }

    resetPages() {
      this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
      this.initPages();
    }

    calculateSlidePosition() {
      this.sliderItemsToShow.forEach((item, index) => {
        // const slideOffset = index * this.slider.clientWidth - this.slider.scrollLeft;
        const slideOffset = item.getBoundingClientRect().left - this.slider.getBoundingClientRect().left;

        this.slidePositionFullPercent[index] = Math.round(slideOffset / (this.slider.clientWidth / 100));
        this.slidePositionPercent[index] = Math.min(100, Math.max(-100, this.slidePositionFullPercent[index]));
        this.slidePositionRatio[index] = this.slidePositionPercent[index] / 100;
      });
    }

    update() {
      // Temporarily prevents unneeded updates resulting from variant changes
      // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
      if ((!this.slider || !this.nextButton) && this.dataset.autoplay === undefined) return;

      this.calculateSlidePosition();

      const previousPage = this.currentPage;

      this.slidePositionPercent.forEach((percent, index) => {
        if(percent >= -50 && percent <= 50) {
          this.currentPage = ++index;
          return false;
        }
      });

      if (this.currentPageElement && this.pageTotalElement) {
        this.currentPageElement.textContent = this.currentPage;
        this.pageTotalElement.textContent = this.totalPages;
      }

      if (this.currentPage != previousPage) {
        this.dispatchEvent(
          new CustomEvent('slideChanged', {
            detail: {
              currentPage: this.currentPage,
              currentElement: this.sliderItemsToShow[this.currentPage - 1],
            },
          })
        );
      }

      this.bulletsToShow.forEach((element, index) => {
        if(this.slider.classList.contains('slider--two-in-row')) {
          index *= 2;
        }
        if (this.currentPage === index + 1 || (this.slider.classList.contains('slider--two-in-row') && this.currentPage === index + 2)) {
          element.classList.add('active');
        } else {
          element.classList.remove('active');
        }
      });

      if (this.enableSliderLooping) return;

      if (this.prevButton) {
        if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
          this.prevButton.setAttribute('disabled', 'disabled');
        } else {
          this.prevButton.removeAttribute('disabled');
        }
      }
      
      if (this.nextButton) {
        if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
          this.nextButton.setAttribute('disabled', 'disabled');
        } else {
          this.nextButton.removeAttribute('disabled');
        }
      }

      // this.pageCount.textContent = this.currentPage;
      // this.pageTotal.textContent = this.totalPages;
    }

    isSlideVisible(element, offset = 0) {
      const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset + this.sliderItemGap;
      return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
    }

    onButtonClick(event, button) {
      if(event) {
        event.preventDefault();
      }

      const step = event?.currentTarget?.dataset?.step || 1;
      button = button || event.currentTarget.name;
      
      this.slideScrollPosition =
        button === 'next'
          ? (this.currentPage + step - 1) * this.sliderItemOffset
          : (this.currentPage - step - 1) * this.sliderItemOffset;

      this.setSlidePosition(this.slideScrollPosition);
    }

    setSlidePosition(position) {
      this.slider.scrollTo({
        left: position
      });
    }

    onBulletClick(index, event) {
      if(event) event.preventDefault();
      if(this.slider.classList.contains('slider--two-in-row')) {
        index *= 2;
      }

      this.slideScrollPosition = index * this.sliderItemOffset;
      this.setSlidePosition(this.slideScrollPosition);

      // const slideScrollPosition = (this.sliderLastItem.clientWidth + this.sliderItemGap) * index;
      // this.slider.scrollTo({
      //   left: slideScrollPosition
      // });
    }

    toNextSlide() {
      let nextSlide;

      if(this.bulletsToShow.length) {
        this.bulletsToShow.forEach((element, index) => {
          if(element.classList.contains('active')) {
            nextSlide = index + 1;
            if(nextSlide >= this.bulletsToShow.length) {
              nextSlide = 0;
            }
            return false;
          }
        });
      } else {
        nextSlide = this.currentPage;
        if(nextSlide >= this.sliderItemsToShow.length) {
          nextSlide = 0;
        }
      }
      if(nextSlide === undefined) return;
      if(this.bulletsToShow.lenght) {
        this.bulletsToShow.forEach(element => element.classList.remove('active'));
        this.bulletsToShow[nextSlide].classList.add('active');
      }
      
      this.onBulletClick(nextSlide);
    }

    startAutoplay() {
      setInterval(() => {
        this.toNextSlide();
      }, +this.dataset.autoplay);
    }
  }

  window.SliderComponent = SliderComponent;
  scriptController.scripts.push('slider-component.js');
  customElements.define('slider-component', SliderComponent);
}